import React from 'react';
import ParallaxSection from './ParallaxSection';
import SectionHeading from './SectionHeading';

const Airfield: React.FC = () => {
  return (
    <ParallaxSection
      id="flugplatz"
      backgroundImage="/images/Flugsportverein_Bilder_7.jpg"
    >
      <div>
        <SectionHeading
          eyebrow="Flugplatz"
          title="Flugplatzdaten"
          subtitle="Hier finden Sie alle wichtigen Informationen zu unserem Flugplatz in Bad Langensalza."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white shadow overflow-hidden rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">Flugplatzinformationen</h3>
              <p className="mt-1 text-sm text-gray-500">
                <a href="/flugplatzinfo" className="text-primary hover:text-primary-dark font-medium">
                  → Detaillierte Informationen für UL Piloten
                </a>
              </p>
            </div>
            <div className="border-t border-gray-200">
              <dl>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Kennung</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">EDEB</dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Koordinaten</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">E 10° 37.30' / N 051° 07.75'</dd>
                </div>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Frequenz</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">125,365 kHz</dd>
                </div>

              </dl>
            </div>
          </div>

          <div className="bg-white shadow overflow-hidden rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">Flugplatzlage</h3>
            </div>
            <div className="border-t border-gray-200 p-4">
              {/* Google Maps Embed */}
              <div className="w-full h-64">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2473.0!2d10.62!3d51.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDA3JzQ1LjAiTiAxMMKwMzcnMTguMCJF!5e0!3m2!1sde!2sde!4v1630000000000!5m2!1sde!2sde" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen={true} 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Flugplatz Bad Langensalza"
                />
              </div>
              <p className="mt-4 text-sm text-gray-500">
                Der Flugplatz liegt ca. 3 km nördlich von Bad Langensalza. 
                Anfahrt über die Thamsbrücker Landstraße.
                <br />
                Standort: Thamsbrücker Landstraße 28, 99947 Bad Langensalza
              </p>
            </div>
          </div>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Airfield; 